import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {DateTime} from 'luxon';

import {Markets} from 'models/Market';

export interface MarketsState {
  readonly markets: Markets;
  readonly loading: boolean;
  readonly failed: boolean;
  readonly lastQueryTime?: string;
}

export type MarketsResponse = Markets;

export const initialState: MarketsState = {
  markets: [] as Markets,
  lastQueryTime: undefined,
  loading: true,
  failed: false,
};

const {actions: MarketsActions, reducer: MarketsReducer} = createSlice({
  name: 'markets',
  initialState,
  reducers: {
    clearMarkets() {
      return initialState;
    },
    getMarkets(state) {
      state.loading = true;
      state.failed = false;
    },
    getMarketsCachedSuccess(state) {
      state.loading = false;
      state.failed = false;
    },
    getMarketsSuccess(state, action: PayloadAction<MarketsResponse>) {
      // A 200 that isn't JSON (login redirect, WAF/error page) reaches us as a
      // raw string, since axios silently skips parsing it. Treat it as a failure
      // instead of persisting it as the markets list.
      if (!Array.isArray(action.payload)) {
        state.loading = false;
        state.failed = true;
        state.lastQueryTime = undefined;
        state.markets = [];
        return;
      }

      state.loading = false;
      state.failed = false;
      state.lastQueryTime = DateTime.local().toISO();
      state.markets = action.payload;
    },
    getMarketsFailure(state) {
      state.failed = true;
      state.loading = false;
    },
  },
});

export {MarketsActions, MarketsReducer};
export default MarketsReducer;
